/*
 * File: worldsApi.ts
 * Project: rosita
 * -----
 * Last Modified: 24 Feb 2022 11:31:31 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ReduxState } from 'redux/store';
import { GetWorldsResponse } from './models/worlds';

/* ******************** Base Query ******************** */
const baseUrl = process.env.REACT_APP_CHUCKIE_SUE_BASE_URL || '';
const functionsKey = process.env.REACT_APP_API_HOST_KEY_CHUCKIE_SUE || '';

export const worldsBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as ReduxState).app.accessToken;

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      headers.set('x-functions-key', functionsKey);
      headers.set('Content-Type', 'application/json');
    }

    return headers;
  }
});

export const chuckieSueWorldsApi = createApi({
  reducerPath: 'chuckieSueWorldsApi',
  baseQuery: worldsBaseQuery,
  endpoints: (builder) => ({
    getWorlds: builder.query<GetWorldsResponse, void>({
      query: () => ({
        url: 'worlds'
      })
    }),
    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetWorldsQuery, useLazyGetWorldsQuery, useGetApiNameQuery, useGetVersionQuery } = chuckieSueWorldsApi;
